export const OPEN_DELAY = 600;
